import { BlockComponent, replaceLinks } from 'lib'

interface Props {
	content: string
}

export const DangerouslyHTML: BlockComponent<Props> = ({ content }) => (
	<div dangerouslySetInnerHTML={{ __html: replaceLinks(content) }} />
)
